/// <amd-module name="Comments/Reactions/Constants" />
import { CommentReactionType } from "Comments/Common/Contracts";
import { IReactionEmojiInfo } from "Comments/Reactions/Contracts";
import * as ReactionResources from "Comments/Reactions/Resources";

export const ReactionTypeToEmojiMap: {
    [reactionType: number]: IReactionEmojiInfo;
} = {
    [CommentReactionType.Like]: {
        encodedValue: "&#x1F44D;",
        description: ReactionResources.ThumbsUp
    },
    [CommentReactionType.Dislike]: {
        encodedValue: "&#x1F44E;",
        description: ReactionResources.ThumbsDown
    },
    [CommentReactionType.Hooray]: {
        encodedValue: "&#x1F389;",
        description: ReactionResources.PartyPopper
    },
    [CommentReactionType.Heart]: {
        encodedValue: "&#x2764;",
        description: ReactionResources.RedHeart
    },
    [CommentReactionType.Smile]: {
        encodedValue: "&#x1F603;",
        description: ReactionResources.SmilingFace
    },
    [CommentReactionType.Confused]: {
        encodedValue: "&#x1F616;",
        description: ReactionResources.ConfoundedFace
    }
};
